<mat-card [class.passwordStep]="stepper.selectedIndex == 1">
  <div class="header">
    <img class="bild-logo" src="assets/thunder-logo.png" height="60"/>
  </div>
  <ng-container *ngIf="stepper.selectedIndex === 1">
    <div class="user">
      <div class="user-chip mat-elevation-z1" (click)="startOver()">
        <div class="email">{{ emailFormControl.value }}</div>
      </div>
    </div>
  </ng-container>
  <form [formGroup]="signInForm" #form="ngForm" (ngSubmit)="signIn()">
    <mat-horizontal-stepper #stepper linear [animationDuration]="'0ms'">
      <mat-step [stepControl]="signInForm.get('email')">
        <div class="step-email">
          <mat-form-field appearance="outline">
            <mat-label>Login</mat-label>
            <input #emailControl matInput placeholder="" formControlName="email" (keyup.enter)="goToStep2()" autocapitalize="off" autocomplete="off">
          </mat-form-field>
          <div class="button">
            <button mat-raised-button color="primary" type="button" (click)="goToStep2()">Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div class="step-password">
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input #passwordControl matInput type="password" autocomplete="off" placeholder="Password" formControlName="password" (keyup.enter)="form.ngSubmit.emit()">
          </mat-form-field>
          <div class="button">
            <button mat-raised-button color="primary" type="button" (click)="form.ngSubmit.emit()">Sign In</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</mat-card>
